if (!customElements.get('uahpet-card-image')) {
  customElements.define('uahpet-card-image', class extends HTMLElement {
    connectedCallback() {
      const image = this.querySelector('.uahpet-card-image__hover');
      if (!image) return;
      const ready = () => {
        if (image.naturalWidth > 0) this.setAttribute('data-hover-ready', '');
      };
      if (image.complete) ready();
      else image.addEventListener('load', ready, { once: true });
    }
  });
}
